import React from "react";
import {
  Metrics,
  Helpers,
  Colors,
  Spacing,
  channelColors as colors,
  Fonts,
  Images,
} from "../../global";
import { Row, Icon, View, Alert } from "../../Components";
import {
  Group,
  Title,
  Button,
  Space,
  FileButton,
  Text,
  Paper,
  SimpleGrid,
  TextInput,
  Stack,
  Image,
  Divider,
  NumberInput,
  ActionIcon,
  Modal,
  Center,
  ThemeIcon,
  Loader,
} from "@mantine/core";
import { ReactComponent as backIcon } from "../../Assets/SVG/Back.svg";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { FaPencil } from "react-icons/fa6";
import { useDisclosure } from "@mantine/hooks";
import { IoTrashBinSharp } from "react-icons/io5";
import { getSenderShares, deleteStoreShare, addProjectShare } from "../../API";
import { useRecoilValue } from "recoil";
import { allSitesAtom } from "../../Atoms/allSitesAtom";
import { useState, useEffect } from "react";
import { project } from "ramda";

import { TiPlus } from "react-icons/ti";

export const StoreEdit = (
  navigate,
  project_id,
  storeName,
  setStoreName,
  storeNumber,
  setStoreNumber,
  storeAddress,
  setStoreAddress,
  storeManager,
  setStoreManager,
  image,
  setImageUpdate,
  setDeleteStore,
  setDeleteStoreLoading,
  deleteStoreLoading,
  deleteProject,
  setUpdateStoreLoading,
  updateStoreLoading,
  updateProject,
  deleteStore,
  handleImageUpload,
  repullStores,
  currentStore,
  user
) => {
  // Hooks for MantineUI Modal Components
  const [openedEditStore, { open: openEditStore, close: closeEditStore }] =
    useDisclosure(false);
  const [openedEditTeam, { open: openEditTeam, close: closeEditTeam }] =
    useDisclosure(false);
  const [
    openedDeleteStore,
    { open: openDeleteStore, close: closeDeleteStore },
  ] = useDisclosure(false);
  const [openedDeleteTeam, { open: openDeleteTeam, close: closeDeleteTeam }] =
    useDisclosure(false);
  const [storeShareRecipients, setStoreShareRecipients] = useState(undefined);
  const [addMemberLoading, setAddMemberLoading] = useState();
  const [deleteMemberLoading, setDeleteMemberLoading] = useState(false);
  const [teamEmail, setTeamEmail] = useState("");
  const [recipientLoading, setRecipientLoading] = useState(false);
  const allSites = useRecoilValue(allSitesAtom);
  
  // Delete Store Function
  const handleDeleteStore = async () => {
    setDeleteStoreLoading(true);
    await deleteProject(project_id)
      .then(async (res) => {
        console.log("deleteProject:", res);
        if (res === true) {
          await repullStores();
          setDeleteStore(false);
          closeDeleteStore();
          navigate("/users");
        }
      })
      .catch((err) => {
        console.log("deleteProject:", err);
      });
    setDeleteStoreLoading(false);
  };

  // Update Store Details Settings
  const handleUpdateStore = async () => {
    setUpdateStoreLoading(true);
    await updateProject(project_id, {
      projectName: storeName,
      projectIdentifier: storeNumber,
      projectLocation: storeAddress,
    })
      .then(async (res) => {
        console.log("updateProject:", res);
        await handleImageUpload();
        await repullStores();
        navigate("/stores");
      })
      .catch((err) => {
        console.log("updateProject:", err);
      });
    setUpdateStoreLoading(false);
  };

  // Getting Shared Recipients for Stores
  const handleGetShares = async () => {
    setRecipientLoading(true);
    try {
      const res = await getSenderShares({
        token: user?.signInUserSession?.idToken?.jwtToken,
      });
      setStoreShareRecipients(res);
      console.log("handleGetShares", res);
    } catch (err) {
      console.log("updateProject:", err);
    } finally {
      setRecipientLoading(false);
    }
  };

  useEffect(() => {
    handleGetShares();
  }, []);

  // Add Share Store Recipient
  const handleAddShareStore = async () => {
    try {
      setAddMemberLoading(true);

      const res = await addProjectShare(
        user?.signInUserSession?.idToken?.jwtToken,
        project_id,
        teamEmail
      );

      handleGetShares();
      setTeamEmail("");

      console.log(
        "Member Added",
        res,
        user?.signInUserSession?.idToken?.jwtToken,
        project_id,
        teamEmail
      );
    } catch (err) {
      console.log("handleAddShareStore Error:", err);
    } finally {
      setAddMemberLoading(false);
    }
  };

  // Delete Share Store Recipient
  const handleDeleteStoreShare = async (shareId) => {
    try {
      setDeleteMemberLoading(true);
      const res = await deleteStoreShare(
        user?.signInUserSession?.idToken?.jwtToken,
        shareId
      );

      handleGetShares();
      closeDeleteTeam();

      console.log("handleDeleteStoreShare", res);
    } catch (err) {
      console.log("handleDeleteStoreShare:", err);
    } finally {
      setDeleteMemberLoading(false);
    }
  };

  // Using this instead of the currentStore state bc it wasnt working
  // We need to move away from prop drilling so heavily, when we use recoil to manage global state we should utilize this and avoid prop drilling as much as possible
  // It makes things harder to maintain & catch errors/bugs, especially when you sharing 15+ pieces of state between components
  const currStore = allSites?.stores?.Items.find(
    (store) => store.project_id === project_id
  );

  console.log("currStore", currStore);

  return (
    <>
      <Group justify="space-between">
        <div>
          <Title order={2}>Store Settings</Title>
          <Text c="dimmed" size="sm">
            Edit Store Details.
          </Text>
        </div>

        <Button
          color={Colors.main}
          variant="outline"
          onClick={() => navigate("/users")}
          radius="sm"
          mr="md"
          h={43}
        >
          <MdKeyboardArrowLeft size="1.6rem" />
          <Text>Back To Stores</Text>
        </Button>
      </Group>

      <Space h="md" />
      <Paper p="md">
        <Group justify="space-between" style={{ position: "relative" }}>
          <Group>
            <Image
              h={225}
              w={{ base: 333, sm: 350, lg: 375 }}
              radius="sm"
              src={image ? image : Images.store}
            />

            <div>
              <Title order={3}>{storeName}</Title>
              <Title order={3}>{"Store Number: " + storeNumber}</Title>
              <Title order={4}>{storeAddress}</Title>
              <Text c="dimmed" size="lg">
                {"Phone: " + "954 555 1234"}
              </Text>
              <Text c="dimmed" size="lg">
                {"Email: " + "exampleEmail@gmail.com"}
              </Text>
            </div>
          </Group>

          {!currStore?.sharedStore && (
            <Group style={{ position: "absolute", top: 0, right: 0 }} gap="xs">
              <ActionIcon color={Colors.main} onClick={openEditStore}>
                <FaPencil />
              </ActionIcon>
            </Group>
          )}
        </Group>
      </Paper>

      <Space h="md" />

      <Paper p="md">
        <Group justify="space-between">
          <Text size="xl" fw={500}>
            Team Members
          </Text>

          <div>
            <TextInput
              placeholder="example@email.com"
              styles={{
                input: { backgroundColor: Colors.gray100 },
              }}
              value={teamEmail}
              onChange={(event) => setTeamEmail(event.currentTarget.value)}
              error={
                teamEmail &&
                !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(teamEmail)
              }
              rightSection={
                <>
                  <ActionIcon
                    color={Colors.main}
                    loading={addMemberLoading}
                    onClick={handleAddShareStore}
                    disabled={
                      !teamEmail ||
                      !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
                        teamEmail
                      )
                    }
                    size="sm"
                  >
                    <TiPlus />
                  </ActionIcon>
                </>
              }
            />
            {teamEmail &&
              !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
                teamEmail
              ) && (
                <Text ta="right" size="xs" c="red">
                  Invalid Email
                </Text>
              )}
          </div>
        </Group>

        <Space h="lg" />

        {recipientLoading ? (
          <Center>
            <Loader />
          </Center>
        ) : (
          <>
            {storeShareRecipients ? (
              <>
                {storeShareRecipients
                  .filter((recipient) => recipient.project_id === project_id)
                  .map((recipient, index) => (
                    <>
                      <Group key={index} gap="xs">
                        <ActionIcon
                          radius="xl"
                          size="sm"
                          variant="subtle"
                          color={Colors.redMain}
                          loading={deleteMemberLoading}
                          onClick={openDeleteTeam}
                        >
                          <IoTrashBinSharp />
                        </ActionIcon>

                        <Text size="md">
                          {recipient.senderSettings.recipientEmailID}
                        </Text>

                        <ActionIcon
                          color={Colors.main}
                          radius="xl"
                          size="sm"
                          variant="subtle"
                          onClick={openEditTeam}
                        >
                          <FaPencil />
                        </ActionIcon>
                      </Group>
                      <Space h="md" />

                      <Modal
                        opened={openedEditTeam}
                        onClose={closeEditTeam}
                        title="Edit Team Member"
                      >
                        Coming Soon...
                      </Modal>
                      <Modal
                        opened={openedDeleteTeam}
                        onClose={closeDeleteTeam}
                      >
                        <Center>
                          <ThemeIcon
                            variant="light"
                            radius={100}
                            size={75}
                            color={Colors.redMain}
                          >
                            <IoTrashBinSharp
                              style={{ width: "70%", height: "70%" }}
                            />
                          </ThemeIcon>
                        </Center>

                        <Center>
                          <Title order={2}>Are You Sure?</Title>
                        </Center>
                        <Text c="dimmed" size="md" ta="center">
                          This action will remove this team member from this
                          store. This process cannot be undone.
                        </Text>
                        <Space h={50} />

                        <Group justify="center">
                          <Button variant="default" onClick={closeDeleteTeam}>
                            Cancel
                          </Button>
                          <Button
                            color={Colors.redMain}
                            onClick={() =>
                              handleDeleteStoreShare(recipient.share_id)
                            }
                            loading={deleteMemberLoading}
                          >
                            Delete
                          </Button>
                        </Group>
                      </Modal>
                    </>
                  ))}
                {storeShareRecipients.filter(
                  (recipient) => recipient.project_id === project_id
                ).length === 0 && (
                  <>You haven't added any team members to this store yet</>
                )}
              </>
            ) : (
              <>You haven't added any team members to this store yet</>
            )}
          </>
        )}
      </Paper>

      <Space h="lg" />

      {!currStore?.sharedStore && (
        <Group justify="flex-end">
          <Button color={Colors.redMain} onClick={openDeleteStore}>
            Delete Store
          </Button>
        </Group>
      )}

      {/* Delete/Edit Modals */}
      <Modal opened={openedDeleteStore} onClose={closeDeleteStore} centered>
        <Center>
          <ThemeIcon
            variant="light"
            radius={100}
            size={75}
            color={Colors.redMain}
          >
            <IoTrashBinSharp style={{ width: "70%", height: "70%" }} />
          </ThemeIcon>
        </Center>

        <Center>
          <Title order={2}>Are You Sure?</Title>
        </Center>
        <Text c="dimmed" size="md" ta="center">
          This will delete your store. This process cannot be undone.
        </Text>
        <Space h={50} />

        <Group justify="center">
          <Button variant="default" onClick={closeDeleteStore}>
            Cancel
          </Button>
          <Button
            color={Colors.redMain}
            onClick={handleDeleteStore}
            loading={deleteStoreLoading}
          >
            Delete
          </Button>
        </Group>
      </Modal>

      <Modal
        opened={openedEditStore}
        onClose={closeEditStore}
        title={<Title order={2}>Edit Store</Title>}
        size="xl"
        centered
      >
        <Center>
          <Row.ImageUpload
            title={"Store Image"}
            image={image ? image : Images.store}
            setImageUpdate={setImageUpdate}
          />
        </Center>

        <Space h="md" />

        <TextInput
          label="Store Name"
          placeholder="Enter Store Name"
          styles={{
            input: { backgroundColor: Colors.gray100 },
          }}
          value={storeName}
          onChange={(event) => setStoreName(event.currentTarget.value)}
        />

        <NumberInput
          label="Store Number"
          placeholder="Enter Store Number"
          styles={{
            input: { backgroundColor: Colors.gray100 },
          }}
          value={storeNumber}
          onChange={setStoreNumber}
          hideControls
          allowDecimal={false}
          allowNegative={false}
        />

        <TextInput
          label="Store Address"
          placeholder="123 Any Street, City, State 00000"
          styles={{
            input: { backgroundColor: Colors.gray100 },
          }}
          value={storeAddress}
          onChange={(event) => setStoreAddress(event.currentTarget.value)}
        />

        <Space h="lg" />

        <Group justify="flex-end">
          <Button
            color={Colors.main}
            loading={updateStoreLoading}
            onClick={handleUpdateStore}
          >
            Save Changes
          </Button>
        </Group>
      </Modal>
    </>
  );
};

export default StoreEdit;